import { render, staticRenderFns } from "./LearnMoreBtn.vue?vue&type=template&id=0b0da544&scoped=true&"
import script from "./LearnMoreBtn.vue?vue&type=script&lang=js&"
export * from "./LearnMoreBtn.vue?vue&type=script&lang=js&"
import style0 from "./LearnMoreBtn.vue?vue&type=style&index=0&id=0b0da544&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0da544",
  null
  
)

export default component.exports